import CoveragePackageModalLink from '../../CoveragePackageModalLink';
import { SelectField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { ChangeEvent } from 'react';
import { useUpdateCoveragePackageInformation } from '../../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../../utils/coverablesUtil';
import type { PrhHolidayHomeOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';
import { holidayHomeContentCovOptionsSelector } from '../../../../../recoil/selectors/holidayHomeContentCovOptionsSelector';
import { refreshCoveragePackagePricesAtom } from '../../../../../recoil/atoms/refreshCoveragePackagePricesAtom';

const HolidayHomeInputSum = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const modalName = getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INPUT-INFO');
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { updateCoveragePackageInformation } =
        useUpdateCoveragePackageInformation<PrhHolidayHomeOnsaDTO>();
    const { flavourName = '', fixedId = '' } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as PrhHolidayHomeOnsaDTO;
    const refreshPrices = useSetRecoilState(refreshCoveragePackagePricesAtom);
    const sumOptions = useRecoilValue(holidayHomeContentCovOptionsSelector);

    const changeSum = (event: ChangeEvent<HTMLSelectElement>): void => {
        const value = event.target.value;
        if (value) {
            setIsLoading(true);
            const isValueAboveManSumThreshold = isNaN(
                parseInt(value?.split(' ')[0].replaceAll('.', ''))
            );
            if (!isValueAboveManSumThreshold) {
                updateCoverableInformation({
                    contentInsuranceSum: value,
                    contentInsuranceManualSum: undefined
                });
            } else {
                updateCoverableInformation({ contentInsuranceSum: value });
            }
            void updateCoveragePackageInformation({
                contentInsuranceSum: value
            }).then(() => {
                refreshPrices({});
                setIsLoading(false);
            });
        }
    };

    return (
        <>
            <div className="u-flex-box u-flex-box--space-between">
                <h4>{getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INPUT-HEADER-HOLIDAY')}</h4>
                <CoveragePackageModalLink
                    modalName={modalName}
                    title={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INPUT-HEADER-HOLIDAY')}
                    description={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INFO-MODAL-PRH')}
                />
            </div>
            <div className="u-spacing-stack-none">
                <SelectField
                    placeholder={coverable.contentInsuranceSum}
                    label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-FIELD-TEXT')}
                    onChange={changeSum}
                    options={sumOptions}
                    value={coverable.contentInsuranceSum}
                    disabled={isLoading}
                ></SelectField>
            </div>
        </>
    );
};

export default HolidayHomeInputSum;
